'use client'

import { Slot } from '@radix-ui/react-slot'
import { cva } from 'class-variance-authority'
import React from 'react'

import type { LucideIconName } from '~/core/ui/IconWrapper'
import IconWrapper from '~/core/ui/IconWrapper'
import { cn } from '~/core/ui/utils'

const closeButtonVariants = cva('flex items-center outline-hidden', {
  variants: {
    disabled: {
      default:
        'hover:text-primary-600 focus:text-primary-600 dark:hover:text-primary-300 dark:focus:text-primary-300 text-gray-600 dark:text-gray-400',
      disabled: 'pointer-events-none text-gray-400 dark:text-gray-700'
    }
  },
  defaultVariants: {
    disabled: 'default'
  }
})

interface CloseButtonProps {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  isDisabled?: boolean
  iconClassName?: string
  iconName?: LucideIconName
  asChild?: boolean
  ref?: React.Ref<HTMLButtonElement>
}

const CloseButton = ({
  isDisabled = false,
  onClick,
  iconClassName = '',
  iconName = 'X',
  asChild,
  ref
}: CloseButtonProps) => {
  const Comp = asChild ? Slot : 'button'

  return (
    <Comp
      ref={ref}
      type="button"
      className={cn(
        closeButtonVariants({ disabled: isDisabled ? 'disabled' : 'default' })
      )}
      onClick={(event) => {
        if (onClick) {
          onClick(event)
        }
      }}>
      <div>
        <IconWrapper className={iconClassName} name={iconName} />
      </div>
    </Comp>
  )
}

CloseButton.displayName = 'CloseButton'

export { CloseButton }
export type { CloseButtonProps }
